<script setup>
import { onMounted, ref, onUpdated, defineProps, defineEmits } from "vue"
import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"

import store from "../../state/store"
import useValues from "../../use/useValues"

const props = defineProps({
  modelValue: Boolean,
  value: {
    required: true,
    type: Object,
  },
  attributes: {
    required: true,
    type: Object,
  },
})

const valueData = ref({
  id: props.value.id,
  attribute_id: props.value.attribute_id,
  value_name: props.value.name,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useValues(
  props,
  emit,
  valueData
)

onUpdated(() => {
  valueData.value = {
    id: props.value.id,
    attribute_id: props.value.attribute_id,
    value_name: props.value.name,
  }
})

onMounted(() => {
  store.dispatch("getAttributesNoPagination")
})
</script>

<template>
  <!-- add value modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" افزودن ویژگی"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
          enctype="multipart/form-data"
        >
          <div class="mb-3">
            <label for="name" class="form-label">ویژگی</label>
            <v-select
              v-model="valueData.attribute_id"
              :options="props.attributes.data"
              label="name"
              :reduce="(attribute) => attribute.id"
              placeholder="جستجوی ویژگی"
              class="mb-3 v-select-rtl"
            />

            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.attribute_id">
                <span>{{ errors.attribute_id[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="name" class="form-label"> نام ویژگی</label>
            <input
              type="text"
              id="name"
              class="form-control"
              placeholder="نام مقدار ویژگی"
              v-model="valueData.value_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.value_name">
                <span>{{ errors.value_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">افزودن ویژگی</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
